<template>
  <div class="ec-line001" v-loading="loading">
    <!-- <the-carrousel :data="slides" />
    <div class="ec-line001__feature">
      <h2 class="ec-line001__feature__title">{{ $t('ec-line001.content.feature') }}</h2>
      <feature-item
        v-for="(item, index) in features"
        :key="index"
        :rank="index + 1"
        :title="item.title"
        :img="item.img"
        :description="item.description"
      />
    </div> -->
    <div class="ec-line001__product">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t('ec-line001.content.listOfProductsHandled') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <the-heading class="lg:mb-4 mb-1">
        {{ $t('ec-line001.content.listOfProductsHandled') }}
      </the-heading>
      <div class="ec-line001__product__list">
        <product-item
          v-for="item in products"
          :key="item.id"
          :id="item.id"
          :img="item.img"
          :title="item.title"
          :description="item.description"
          :category="item.category"
          :price="item.price"
          :listed-price="item.listed_price"
          :sale-type="item.sale_type"
          :url="{ name: 'EC_LINE002', params: { id: item.id } }"
        />
        <div v-observe-visibility="visibilityChanged"></div>
      </div>
    </div>
  </div>
</template>

<script>
// Brushup_160
// import TheCarrousel from '@/components/TheCarrousel.vue'
// import FeatureItem from '@/components/ec-line001/FeatureItem.vue'
import MockSlides from '@/mocks/ec-line001-slides'
import MockFeatures from '@/mocks/ec-line001-features'
import ProductItem from '@/components/ProductItem.vue'
import { ProductService } from '@/services'
import { ENV_KEY } from '@/constants/env'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  components: {
    // TheCarrousel,
    // FeatureItem,
    ProductItem,
    TheHeading,
  },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      slides: MockSlides,
      features: MockFeatures,
      products: [],
      loading: false,
      pagination: {},
      page: 1,
      record_limit: 50,
      isFirstLoad: true,
    }
  },
  created() {
    this.fetchData()
    this.sendAdv()
  },
  methods: {
    async fetchData() {
      this.loading = true

      const { data } = await ProductService.getProducts({
        product_status: 1,
        page: this.page,
        record_limit: this.record_limit,
      }) // public product

      this.pagination = data.pagination
      this.products.push(
        ...data.items.map((i) => {
          const { minPrice, minPrice01 } = this.getMinPrice(i)

          const listedPrice =
            Number(minPrice01) === 0 || minPrice01 == null ? '' : this.$n(minPrice01, 'currency', 'ja-JP')

          return Object.assign({
            id: i.product_id,
            img: `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${i.product_image}`,
            title: i.product_name,
            description: i.product_caption,
            price: this.$n(minPrice, 'currency', 'ja-JP'),
            listed_price: listedPrice,
            sale_type: i.sale_type_id,
          })
        })
      )
      this.loading = false
      this.isFirstLoad = false
    },
    visibilityChanged(isVisible) {
      if (!isVisible || this.isFirstLoad) {
        return
      }

      if (this.products.length >= this.pagination.total_items) {
        return
      }

      this.page += 1
      this.fetchData()
    },
    getMinPrice(product) {
      const price = (product) =>
        Object.assign({
          [this.Constants.SALE_TYPE.NORMAL]: Number(product.product_retail_price_min_after_tax),
          [this.Constants.SALE_TYPE.SUBSCRIPTION]: Number(product.product_regular_price_min_after_tax),
          [this.Constants.SALE_TYPE.BOTH]: Number(product.product_regular_price_min_after_tax),
        })

      if (product.is_set_sku) {
        switch (product.sale_type_id) {
          case this.Constants.SALE_TYPE.NORMAL:
            return {
              minPrice: price(product)[this.Constants.SALE_TYPE.NORMAL],
              minPrice01: product.price02_matching_price01_sku_after_tax,
            }
          case this.Constants.SALE_TYPE.SUBSCRIPTION:
          case this.Constants.SALE_TYPE.BOTH:
          default:
            return {
              minPrice: price(product)[this.Constants.SALE_TYPE.SUBSCRIPTION],
              minPrice01: product.price03_matching_price01_sku_after_tax,
            }
        }
      } else {
        return {
          minPrice: price(product)[product.sale_type_id],
          minPrice01:
            product.sale_type_id === this.Constants.SALE_TYPE.NORMAL
              ? product.price02_matching_price01_sku_after_tax
              : product.price03_matching_price01_sku_after_tax,
        }
      }
    },
    async sendAdv() {
      const { adcd, ad_user_id } = this.$route.query

      if (adcd && ad_user_id) {
        localStorage.setItem(this.Constants.ADCD, adcd)
        localStorage.setItem(this.Constants.AD_USER_ID, ad_user_id)

        const query = { ...this.$route.query }

        delete query.adcd
        delete query.ad_user_id

        this.$router.replace({ query })
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line001.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line001.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line001.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/ec-line001.scss';
</style>
